import React from "react";;
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import DateHelper from "../DateHelper/DateHelper";
import { differenceInSeconds } from 'date-fns';

class PortalReservationCheckout extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      balance_due: this.getBalanceDue(),
      card: {},
      cards: [],
      displayNewCustomerCard: false,
      errors: [],
      checkout_permitted: this.isCheckoutPermitted(),
      loading: false,
      payment_card_id: '',
      step: '',
    }

    // cards
    if (this.props.reservation_segment && this.props.reservation_segment.customer && this.props.reservation_segment.customer.cards) {
      this.state.cards = this.props.reservation_segment.customer.cards
    }

    this.onAddCard = this.onAddCard.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeCardInput = this.onChangeCardInput.bind(this);
  }

  componentDidMount() {
    if (this.state.checkout_permitted && this.state.balance_due <= 0) {
      this.onFinish();
    }
  }

  /**
  * Render functions
  */

  render() {
    return (
      <div className="PortalReservationCheckout">
        {this.renderErrors()}
        {this.state.checkout_permitted && this.state.balance_due > 0 && this.state.step !== 'finished' ? this.renderForm() : null}
        {
          !this.state.checkout_permitted
          ?
          <div>
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div style={{maxWidth: '420px', margin: '10px auto'}} className="alert alert-danger">
                    <div className="text-center"><strong>{I18n.t('check_out_not_available')}</strong></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={this.buttons()} />
      </div>
    );
  }

  renderErrors() {
    if (this.state.errors && this.state.errors.length > 0) {
      var errors = this.state.errors.map((error) => {
        return <li key={error}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>
            {errors}
          </ul>
        </div>
      );
    }
  }

  renderForm() {
    return (
      <div>
        <div className="container">
          <div className="room-type">
            <div className="row">
              <div className="col-sm-3">
                <div className="panel panel-default">
                  <div className="panel-body">
                    <label style={{color: '#777', marginBottom: '0px'}}>{I18n.t('payment_amount')}</label>
                    <h3 style={{marginTop: '4px', marginBottom: '0px'}}>${new Intl.NumberFormat().format(this.state.balance_due / 100)}</h3>
                    <div className="help-block">{I18n.t('this_room_requires_a_payment_before_check_out')}</div>
                  </div>
                </div>
              </div>
              <div className="col-sm-9">
                {/*this.renderErrors()*/}
                {this.renderCardsOrCardForm('payment_card')}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCardsOrCardForm(card_type_name) {
    if (this.state.displayNewCustomerCard || this.state.cards.length === 0) {
      return (
        <div className="PaymentMethod">
          <div className="card" style={{marginBottom: '7px'}}>
            <CreditCardForm
              card={this.state.card}
              customer={this.props.reservation_segment.customer}
              onChangeCardInput={this.onChangeCardInput}
              stacked={true}
              additionalClasses="container"
            />
          </div>
          {this.state.cards.length > 0 ? <p><a href="#" onClick={this.onAddCard}>{I18n.t(!this.state.displayNewCustomerCard ? 'add_new_card' : 'use_existing_cards')}</a></p> : null}
        </div>
      );
    } else {
      var cards = this.state.cards.map((card) => {
        return (
          <div className={"card well " + (this.state[card_type_name + '_id'] == card.id ? 'card-selected' : '')} key={card.id} >
            <label>
              <input type="radio" name={card_type_name + '_id'} value={card.id} checked={this.state[card_type_name + '_id'] == card.id} onChange={this.onChange} />
              <span className={"credit-card-icon small " + card.brand}></span>
              {I18n.t('ending_in').toLowerCase()} <strong>{card.last_4}</strong><span style={{marginLeft: '-5px'}}>,</span> {I18n.t('exp').toLowerCase()} <strong>{card.month}/{card.year}</strong>
            </label>
          </div>
        );
      });

      return (
        <div className="PaymentMethod">
          <div className="cards">{cards}</div>
          <p><a href="#" onClick={this.onAddCard}>{I18n.t(!this.state.displayNewCustomerCard ? 'add_new_card' : 'use_existing_cards')}</a></p>
        </div>
      );
    }
  }

  /**
  * Change handlers
  */

  onAddCard() {
    var state = {displayNewCustomerCard: !this.state.displayNewCustomerCard};
    if (this.state.step === 'payment') {
      state.payment_card_id = ''
    } else if (this.state.step === 'incidental_deposit') {
      state.incidental_deposit_card_id = ''
    }
    this.setState(state);
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  onChangeCardInput(e) {
    var { card } = this.state;
    card[e.target.name] = e.target.value
    this.setState({card: card});
  }

  onFinish() {
    this.setState({loading: true}, () => {
      if (this.state.balance_due > 0) {
        this.createPaymentAPI().then((data) => {
          if (data.success) {
            this.checkOutAPI().then((data) => {
              if (data.success) {
                this.setState({loading: false, step: 'finished'})
                window.refresh_data(I18n.t('check_out_successful'));
                window.parent.$('.modal').modal('hide');
              } else {
                this.setState({loading: false, errors: [I18n.t('problem_with_check_out')]})
              }
            });
          } else {
            this.setState({loading: false, errors: [I18n.t('problem_with_check_out')]})
          }
        })
      } else {
        this.checkOutAPI().then((data) => {
          if (data.success) {
            this.setState({loading: false, step: 'finished'})
            window.refresh_data(I18n.t('check_out_successful'));
            window.parent.$('.modal').modal('hide');
          } else {
            this.setState({loading: false, errors: [I18n.t('problem_with_check_out')]})
          }
        });
      }
    })
  }

  onNext() {
    if (this.state.displayNewCustomerCard || this.state.cards.length === 0) {
      // save card first
      this.setState({loading: true, errors: []}, () => {
        this.saveCardAPI().then((data) => {
          if (data && data.errors) {
            this.setState({loading: false, errors: data.errors});
          } else {
            var card = data.success;
            var { cards } = this.state;
            cards.unshift(card);
            this.setState({loading: false, cards: cards, payment_card_id: card.id, displayNewCustomerCard: false, card: {}}, () => {
               this.onFinish();
            });
          }
        });
      });
    } else if (this.state.payment_card_id && this.state.payment_card_id !== '') {
      // all good to proceed
      this.onFinish();
    } else {
      this.setState({errors: [I18n.t('please_select_a_card')]})
    }
  }

  /**
  * API endpoint functions
  */

  checkOutAPI() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.props.check_out_path,
        type: 'POST',
        data: {
          reservation_segment_id: this.props.reservation_segment.id,
        },
      }).done(function(data) {
        resolve(data)
      });
    });
  }

  createPaymentAPI() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.props.create_payment_path,
        type: 'POST',
        data: {
          reservation_segment_id: this.props.reservation_segment.id,
          card_id: this.state.payment_card_id,
          amount: this.state.balance_due,
          all_folios: true,
        },
      }).done(function(data) {
        resolve(data)
      });
    });
  }

  saveCardAPI() {
    return new Promise((resolve, reject) => {
      var { card } = this.state
      card.customer_id = this.props.reservation_segment.customer.id
      card.first_name = this.state.card.name_on_card ? this.state.card.name_on_card.split(' ')[0] : null
      card.last_name = this.state.card.name_on_card ? this.state.card.name_on_card.split(' ')[1] : null
      card.month = this.state.card.expiration_date ? this.state.card.expiration_date.split('/')[0] : null
      card.year = this.state.card.expiration_date ? '20' + this.state.card.expiration_date.split('/')[1] : null
      // console.log('card', card)
      $.ajax({
        url: this.props.customer_store_card_path,
        type: 'POST',
        data: card,
      }).done(function(data) {
        resolve(data)
      });
    });
  }

  /**
  * Helper functions
  */

  buttons() {
    var self = this;
    var btns = [];

    if (!this.state.checkout_permitted || (this.state.checkout_permitted && this.state.balance_due === 0)) {
      btns.push({
        name: I18n.t('done'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      });
    } else {
      btns.push({
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      });

      btns.push({
        name: I18n.t('next'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation();
          e.preventDefault();

          self.onNext();
        }
      })
    }

    return btns;
  }

  getBalanceDue() {
    var balance_due = 0

    if (this.props.reservation_segment && this.props.reservation_segment.folios && this.props.reservation_segment.folios.length > 0) {
      for (var i = 0, ilen = this.props.reservation_segment.folios.length; i < ilen; i++) {
        balance_due = balance_due + this.props.reservation_segment.folios[i].balance
      }
    }

    return balance_due
  }

  isCheckoutPermitted() {
    if (this.props.reservation_segment) {
      var today = new Date(DateHelper.today());
      var check_out_date = DateHelper.parseDateFromBackend(this.props.reservation_segment.check_out_date);
      var check_out_diff = differenceInSeconds(today, check_out_date) !== 0 ? differenceInSeconds(today, check_out_date) / 86400 : 0;

      if (this.props.reservation_segment.status === 'checked_in' && check_out_diff <= 0) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
};

export default PortalReservationCheckout
